import Modal from '@/components/common/Modal';
import Spacer from '@/components/common/Spacer';
import Text from '@/components/common/Text';
import usePutUnsubscribeWorker from '@/hooks/usePutUnsubscribeWorker';
import useCompanyInfo from '@/hooks/useCompanyInfo';

interface Props {
  setIsShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedWorkers: number[];
  resetSelectedUnsubscribeWorkerList?: VoidFunction;
}

const UnsubscribeWorkersModal = ({
  setIsShowModal,
  selectedWorkers,
  resetSelectedUnsubscribeWorkerList,
}: Props) => {
  const { mutate: unsubscribeWorker } = usePutUnsubscribeWorker();
  const { data: companyData } = useCompanyInfo();
  
  const subscriptionEndDate = companyData?.data.subscriptionEndDate;

  const onUnsubscribeClick = () => {
    unsubscribeWorker({ workerId: selectedWorkers });
    setIsShowModal(false);
    resetSelectedUnsubscribeWorkerList && resetSelectedUnsubscribeWorkerList();
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}년 ${month}월 ${day}일`;
  };

  return (
    <Modal
      setIsModalOpen={setIsShowModal}
      isWarning
      onClickConfirm={onUnsubscribeClick}
    >
      <Spacer y='1.875rem' />
      <Text fontSize='1.375rem' fontWeight={700}>
        선택한 작업자({selectedWorkers.length}명) 자동 결제를 해제하시겠습니까?
      </Text>
      <Spacer y='0.75rem' />
      <Text fontSize='1rem' fontWeight={400} color='#666'>
        작업자는 계속 사용할 수 있지만, 다음 달 자동 결제에서 제외됩니다.
        {subscriptionEndDate && (
          <>
            <br />
            작업자는 {formatDate(subscriptionEndDate)}부터 사용이 중단됩니다.
          </>
        )}
      </Text>
      <Spacer y='2.5rem' />
    </Modal>
  );
};

export default UnsubscribeWorkersModal;
